export const ANIMATION_DURATION = 300;
